module.exports = __webpack_public_path__ + "static/img/7.3556238f.png";